export const PrefixConstants = {
    STORAGE_KEY_SNIPPETS: 'snippets'
};